import { agentProductionTerms as apt } from '../../constants';
import { marketShareTerms as t } from './index';

export const marketShareColumns = Object.freeze({
    officeId: { id: 'officeId', label: apt.officeId },
    officeName: { id: 'officeName', label: t.office },
    address: { id: 'address', label: apt.address },
    underContractVolume: { id: 'ucVolume', label: t.underContract$Volume },
    ucVolumeAlt: { id: 'ucVolumeAlt', label: t.underContract$Volume, keyField: 'volume' },
    underContractUnits: { id: 'ucUnits', label: t.underContractNumUnits },
    ucUnitsAlt: { id: 'ucUnitsAlt', label: t.underContractNumUnits, keyField: 'units' },
    streetName1: { id: 'streetName1', label: apt.address },
    streetName: { id: 'streetName', label: apt.street },
    streetNum: { id: 'streetNum', label: apt.stNumber },
    newListingVolume: { id: 'newListVolume', label: t.newListing$ },
    newVolume: { id: 'newVolume', label: t.newListing$, keyField: 'volume' },
    newListingUnits: { id: 'newListUnits', label: t.newListingNum },
    newUnits: { id: 'newUnits', label: t.newListingNum, keyField: 'units' },
    forSaleVolume: { id: 'actVolume', label: t.forSale$ },
    fsVolume: { id: 'fsVolume', label: t.forSale$, keyField: 'volume' },
    forSaleUnits: { id: 'actUnits', label: t.forSaleNum, keyField: 'volume' },
    fsUnits: { id: 'fsUnits', label: t.forSaleNum, keyField: 'units' },
    averagePrice: { id: 'averagePrice', label: t.averagePrice },
    avgPrice: { id: 'avgPrice', label: t.averagePrice },
    averageDom: { id: 'averageDom', label: t.dom },
    avgDom: { id: 'avgDom', label: t.dom },
    avgListDom: { id: 'avgListDom', label: t.dom },
    dom: { id: 'dom', label: t.dom },
    cdom: { id: 'cdom', label: apt.cdom },
    agentCount: { id: 'agentCount', label: t.mlsIds },
    mlsAgentCount: {id:'mlsAgentCount', label: t.mlsIds},
    city: { id: 'city', label: apt.city },
    stateCode: { id: 'stateCode', label: t.state },
    zipCode: { id: 'zipCode', label: apt.zip },
    zipcode: { id: 'zipcode', label: apt.zip },
    county: { id: 'county', label: apt.county },
    phoneNumber: { id: 'phoneNumber', label: t.phone },
    office: { id: 'office', label: apt.office },
    brokerName: { id: 'brokerName', label: apt.broker },
    listVolume: { id: 'listVolume', label: t.list$ },
    listUnits: { id: 'listUnits', label: t.listNum },
    listOfficeId: { id: 'listOfficeId', label: t.listOfficeId },
    listOfficeName: { id: 'listOfficeName', label: apt.listOffice },
    sellOfficeId: { id: 'sellOfficeId', label: t.sellOfficeId },
    sellOfficeName: { id: 'sellOfficeName', label: apt.sellOffice },

    spOp: { id: 'spOp', label: t.spOp },
    spLp:{id:'spLp', label: t.spLp },
    spop: { id: 'spop', label: apt.spOp },
    splp: { id: 'splp', label: apt.splp },
    listSpop: { id: 'listSpop', label: t.spOp },
    sellSpop: { id: 'sellSpop', label: t.spOp },
    clr: { id: 'clr', label: t.closedToList },
    closeListRatio: { id: 'closeListRatio', label: t.closedToList },
    sellVolume: { id: 'sellVolume', label: t.sell$ },
    sellUnits: { id: 'sellUnits', label: t.sellNum },

    totalVolume: { id: 'totalVolume', label: t.total },
    totalUnits: { id: 'totalUnits', label: t.totalNum },
    totalAverageDom: { id: 'totalAverageDom', label: t.dom },

    listAverageDom: { id: 'listAverageDom', label: t.dom },
    avgSellDom: { id: 'avgSellDom', label: t.dom },
    totalAvgPrice: { id: 'totalAvgPrice', label: t.averagePrice },
    totalAveragePrice: { id: 'totalAveragePrice', label: t.averagePrice },
    sellAvgPrice: { id: 'sellAvgPrice', label: t.averagePrice },
    sellAveragePrice: { id: 'sellAveragePrice', label: t.averagePrice },
    listAvgPrice: { id: 'listAvgPrice', label: t.averagePrice },
    listAveragePrice: { id: 'listAveragePrice', label: t.averagePrice },
    prodAgentTotalUnits: { id: 'prodAgentTotalUnits', label: t.unitsPerProducingAgent },
    prodAgentTotalVolume: { id: 'prodAgentTotalVolume', label: t.volumePerProducingAgent },
    prodAgentSellVolume: { id: 'prodAgentSellVolume', label: t.volumePerProducingAgent },
    prodAgentSellUnits: { id: 'prodAgentSellUnits', label: t.unitsPerProducingAgent },
    prodAgentListUnits: { id: 'prodAgentListUnits', label: t.unitsPerProducingAgent },
    prodAgentListVolume: { id: 'prodAgentListVolume', label: t.volumePerProducingAgent },
    prodAgentVolume: { id: 'prodAgentVolume', label: t.volumePerProducingAgent },
    prodAgentUnits: { id: 'prodAgentUnits', label: t.unitsPerProducingAgent },
    orgPrice: { id: 'orgPrice', label: apt.originalPrice },
    listPrice: { id: 'listPrice', label: apt.listPrice },
    price: { id: 'price', label: apt.soldPrice },
    soldPrice: { id: 'soldPrice', label: apt.soldPrice },
    date: { id: 'date', label: apt.soldDate },
    priceChangeCnt: { id: 'priceChangeCnt', label: apt.priceChangeCnt },

    avgTotalDom: { id: 'avgTotalDom', label: t.dom },

    marketSharePct: { id: 'marketSharePct', label: t.marketSharePct },
    unitSharePct: { id: 'unitSharePct', label: t.unitPct },
    volumeSharePct: { id: 'volumeSharePct', label: t.volumePct },
    prodAgentCount: { id: 'prodAgentCount', label: t.producingAgents },
    prodAgentSearchCount: { id: 'prodAgentSearchCount', label: t.producingAgents },
    listProdAgentSearchCount: { id: 'listProdAgentSearchCount', label: t.producingAgents },
    sellProdAgentSearchCount: { id: 'sellProdAgentSearchCount', label: t.producingAgents },
    totalProdAgentSearchCount: { id: 'totalProdAgentSearchCount', label: t.producingAgents },
    officeCount: { id: 'officeCount', label: t.numOfOffices },
    mlsOfficeCount: { id: 'mlsOfficeCount', label: t.numOfOffices },
    area: { id: 'area', label: t.area },
    mlsArea: { id: 'mlsArea', label: t.area },
    rank: { id: 'rank', label: t.rank },
    isSelected: { id: 'isSelected', label: t.isSelected },
    areaId: { id: 'areaId', label: apt.area },
    mlsId: { id: 'mlsId', label: t.mlsIds },
    listingStatus: { id: 'listingStatus', field: 'status', label: t.status },
    typeName: { id: 'typeName', label: apt.type },
    mlsNum: { id: 'mlsNum', label: apt.mlsNum },
    bankProperty: { id: 'bankProperty', label: apt.bankProperty },
    bedrooms: { id: 'bedrooms', label: apt.bd },
    fullBaths: { id: 'fullBaths', label: apt.ba },
    squareFt: { id: 'squareFt', label: apt.sqft },
    costPerSqft: { id: 'costPerSqft', label: apt.dollarsPerSqft },
    lotSizeSquareFt: { id: 'lotSizeSquareFt', label: apt.lotSizeSqft },
    lotSizeAcres: { id: 'lotSizeAcres', label: apt.lotSizeAcres },
    yearBuilt: { id: 'yearBuilt', label: apt.yearBuilt },
    listAgent: { id: 'listAgent', label: apt.listAgent },
    sellAgent: { id: 'sellAgent', label: apt.sellAgent },
    doubleSided: { id: 'doubleSided', label: apt.dbl },
    bankStatus: { id: 'bankStatus', label: apt.bankProperty },

    groupName: { id: 'groupName', label: t.group }
});
